const maskCPF = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d{1,2})/, "$1-$2")
    ?.replace(/(-\d{2})\d+?$/, "$1");
};
const removeMask = (value) => {
  return value?.replace(/\D/g, "");
};
const maskPhone = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "($1) $2")
    ?.replace(/(\d{5})(\d)/, "$1-$2")
    ?.replace(/(-\d{4})(\d+?)$/, "$1");
};
const maskCellPhone = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "($1) $2")
    ?.replace(/(\d{4})(\d)/, "$1-$2")
    ?.replace(/(-\d{4})(\d+?)$/, "$1");
};
const maskCnpj = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1/$2")
    ?.replace(/(\d{4})(\d)/, "$1-$2")
    ?.replace(/(-\d{2})\d+?$/, "$1");
};
// Formata CPF ou CNPJ reconhecendo qual é pela quantidade de dígitos.
//
// Até 11 dígitos formata como CPF, acima disso como CNPJ. A mesma regra serve
// para os dois usos: exibir um documento já salvo (11 dígitos = CPF, 14 = CNPJ)
// e mascarar digitação em andamento, que vai se formatando como CPF e vira
// CNPJ ao chegar no 12º dígito.
//
// Vale para documento guardado sem zero à esquerda: um CPF que virou 10
// dígitos continua caindo em CPF, e um CNPJ com 13 continua caindo em CNPJ.
const maskCpfCnpj = (value) => {
  const digitos = String(value ?? "").replace(/\D/g, "");
  if (!digitos) return "";

  return digitos.length <= 11 ? maskCPF(digitos) : maskCnpj(digitos);
};

// Rótulo do documento — "CPF" ou "CNPJ" — pela mesma regra do maskCpfCnpj,
// para que rótulo e formatação nunca discordem. Devolve "" quando não há
// documento, em vez de chutar um tipo.
const tipoDocumento = (value) => {
  const digitos = String(value ?? "").replace(/\D/g, "");
  if (!digitos) return "";

  return digitos.length > 11 ? "CNPJ" : "CPF";
};

const isValidCPF = (cpf) => {
  if (
    typeof cpf !== "string" ||
    cpf.length !== 11 ||
    !Array.from(cpf).filter((e) => e !== cpf[0]).length
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export {
  maskCPF,
  removeMask,
  maskPhone,
  maskCellPhone,
  maskCnpj,
  maskCpfCnpj,
  tipoDocumento,
  isValidCPF,
};
